import React from "react"
import { Disclosure, Transition } from "@headlessui/react"

import { CaretIcon, Markdown } from "components/Elements"
import "./Accordion.scoped.scss"

type AccordionItemProps = {
	title: string
	description: string
	itemNumber: number
}

export const AccordionItem: React.FC<AccordionItemProps> = ({ title, description, itemNumber }) => {
	return (
		<div className="c-accordion-item mb-8">
			<div className="c-accordion-item__index">{itemNumber}</div>
			<Disclosure>
				{({ open }) => (
					<>
						<Disclosure.Button className="c-accordion-item__title px-14 py-2 w-full">
							<h3 className="mb-0">{title}</h3>
							<CaretIcon
								size="32"
								className={`c-accordion-item__title__caret ${
									open ? "is-active" : ""
								}`}
							/>
						</Disclosure.Button>
						<Transition
							show={open}
							enter="transition duration-50 ease-out"
							enterFrom="transform scale-95 opacity-0"
							enterTo="transform scale-100 opacity-100"
							leave="transition duration-35 ease-out"
							leaveFrom="transform scale-100 opacity-100"
							leaveTo="transform scale-95 opacity-0"
						>
							<Disclosure.Panel
								static
								className="c-accordion-item__description p-9 leading-6"
							>
								<Markdown
									specificComponents={{
										h4: ({ children }: any) => (
											<h4 className="c-h4 text-primary font-bold mb-2 mt-6">
												{children}
											</h4>
										),
										a: ({ href, children }: any) => (
											<a
												className="font-bold"
												target="_blank"
												rel="noopener noreferrer"
												href={href}
											>
												{children}
											</a>
										),
									}}
								>
									{description}
								</Markdown>
							</Disclosure.Panel>
						</Transition>
					</>
				)}
			</Disclosure>
		</div>
	)
}
